// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__GmpyJ","TabsOptions":"Tabs_TabsOptions__AapAa","Active":"Tabs_Active__h9ECS"};